import { Box, Card, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzTitleBox from "src/components/core-components/mui/title-box/title-box";

interface VteRiskFactorDescriptionProps {
    formData: any;
    masterFormData: any;
    handleChange: (field: string, value: any) => void;
    handleMasterChange: (field: string, value: any) => void;
    extraAccess?: boolean;
}

function VteRiskFactorDescription({ formData, masterFormData, handleChange, handleMasterChange, extraAccess }: VteRiskFactorDescriptionProps) {
    const { t } = useTranslate();

    return (
        <Card sx={{ marginBottom: "5px" }}>
            <ByzTitleBox title={t("risk_assasement-in-pregnancy.dvt-prophylaxis-by-risk")} center sx={{ marginLeft: "10px", marginRight: "10px", width: "calc(100% - 20px)", }} />
            <Grid container spacing={1}>
                <Grid item xs={12} md={8} >

                    <Box sx={{
                        padding: "16px",
                    }}>
                        <ByzTitleBox title="&nbsp;" center />

                        <TableContainer sx={{ mt: 1, maxWidth: "100%", border: "2px solid rgba(0, 0, 0, 0.1)", }}  >

                            <Table aria-label="simple table" size="small" stickyHeader >
                                <TableHead >
                                    <TableRow  >

                                        <TableCell sx={{ fontWeight: "bold", }}>
                                            {t("risk_assasement-in-pregnancy.total-risk-score")}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", }}>

                                            {t("risk_assasement-in-pregnancy.risk-without-prophylaxis")}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", }}>
                                            {t("risk_assasement-in-pregnancy.dvt-prophylaxis-suggestion")}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            {"<=5"}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.very-high-risk")}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {"3-4"}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.high-risk")}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.standard-prophylaxis")}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {"2"}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.moderate-risk")}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.standard-prophylaxis")}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {"0-1"}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.low-risk")}
                                        </TableCell>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.no-prophylaxis-needed")}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4} paddingTop={"1rem"}>
                    <Box sx={{ p: 2 }}>
                        <ByzTitleBox title={t("risk_assasement-in-pregnancy.general-measures")} center />

                        <TableContainer sx={{ mt: 1, maxWidth: "100%", border: "2px solid rgba(0, 0, 0, 0.1)", }}  >
                            <Table aria-label="simple table" size="small" stickyHeader >
                                <TableHead>
                                    <TableRow >
                                        <TableCell sx={{ fontWeight: "bold" }}>
                                            {t("risk_assasement-in-pregnancy.medications")}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold" }}>
                                            {t("risk_assasement-in-pregnancy.dosages")}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>

                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.fondaparinux")}
                                        </TableCell>
                                        <TableCell>
                                            {"2.5 mg 1x1 SC"}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.nadroparin")}
                                        </TableCell>
                                        <TableCell>
                                            {"3400 IU 1x1 SC"}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.dalteparin")}
                                        </TableCell>
                                        <TableCell>
                                            {"5000 IU 1x1 SC"}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.enoxaparin")}
                                        </TableCell>
                                        <TableCell>
                                            {"40 mg 1x1 SC"}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {t("risk_assasement-in-pregnancy.ufh")}
                                        </TableCell>
                                        <TableCell>
                                            {"5000 IU 2-3x1 SC"}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </Box>
                </Grid>
                <Grid item xs={12} md={12} paddingTop={"1rem"} padding={"1rem"} >
                    <ByzMuiTypography className="w-full" textAlign={"left"} color={"red"} sx={{ fontSize: "11px", }}>
                        {t("risk_assasement-in-pregnancy.description-x")}
                    </ByzMuiTypography>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ fontSize: "0.8rem" }}>
                <Grid item xs={12} md={4} >

                    <Box sx={{ padding: "10px" }}>
                        <ByzTitleBox title={t("risk_assasement-in-pregnancy.mechanical-contradictions")} center />

                        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.PERIPHERAL_ARTER_DISEASE === 1} onChange={(e) => handleMasterChange("PERIPHERAL_ARTER_DISEASE", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.pad")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.CHF_MASTER === 1} onChange={(e) => handleMasterChange("CHF_MASTER", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.chf")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.ACUTE_SUPERFICIENT_HEART_FAILR === 1} onChange={(e) => handleMasterChange("ACUTE_SUPERFICIENT_HEART_FAILR", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.acute-heart-failure")}
                            </Grid>

                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4} paddingTop={"1rem"}>
                    <Box sx={{ padding: "10px" }}>
                        <ByzTitleBox title={t("risk_assasement-in-pregnancy.absolute-anti-coag-contradictions")} center />


                        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.BLEEDING_DIATHESIS === 1} onChange={(e) => handleMasterChange("BLEEDING_DIATHESIS", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.bleeding-diathesis")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.HVNG_HAD_HIT_OR_PRSNC_OF_HTS === 1} onChange={(e) => handleMasterChange("HVNG_HAD_HIT_OR_PRSNC_OF_HTS", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.hit-history")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.USE_OF_ORAL_ANTICOAGULANTS === 1} onChange={(e) => handleMasterChange("USE_OF_ORAL_ANTICOAGULANTS", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.oral-anticoagulants")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.INTRAOCULAR_INTRACRANAIL_SRGRY === 1} onChange={(e) => handleMasterChange("INTRAOCULAR_INTRACRANAIL_SRGRY", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.intraocular-surgery")}
                            </Grid>

                        </Grid>

                    </Box>
                </Grid>
                <Grid item xs={12} md={4} paddingTop={"1rem"}>
                    <Box sx={{ padding: "10px", }}>
                        <ByzTitleBox title={t("risk_assasement-in-pregnancy.relative-anti-coag-contradictions")} center />
                        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.CEREBRAL_HEMORRHAGE_STORY === 1} onChange={(e) => handleMasterChange("CEREBRAL_HEMORRHAGE_STORY", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.cerebral-bleeding")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.TROMBOSIT === 1} onChange={(e) => handleMasterChange("TROMBOSIT", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.low-platelet-or-inr")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.HYPRTNSV_CRISIS_UNCTRLD_HYPRTN === 1} onChange={(e) => handleMasterChange("HYPRTNSV_CRISIS_UNCTRLD_HYPRTN", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.uncontrolled-hypertension")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.BACTERIAL_ENDOCARDITIS === 1} onChange={(e) => handleMasterChange("BACTERIAL_ENDOCARDITIS", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.bacterial-endocarditis")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.ACTV_PTC_ULSR_GSTR_INTL_BLDNG === 1} onChange={(e) => handleMasterChange("ACTV_PTC_ULSR_GSTR_INTL_BLDNG", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.active-ulcer-or-gi-bleed")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.LST_24_HRS_FNC_OR_EPDRL_ANSTHS === 1} onChange={(e) => handleMasterChange("LST_24_HRS_FNC_OR_EPDRL_ANSTHS", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.recent-puncture")}
                            </Grid>
                            <Grid item xs={12} md={12} >
                                <ByzMuiCheckBox checked={masterFormData.KERTIN_CLANNS_LOW_DOSE_ST_GFR === 1} onChange={(e) => handleMasterChange("KERTIN_CLANNS_LOW_DOSE_ST_GFR", e.target.checked ? 1 : 0)} disabled={!extraAccess} />{t("risk_assasement-in-pregnancy.low-gfr-note")}
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12} paddingTop={"1rem"}>
                    <Box sx={{ padding: "10px" }}>
                        <ByzTitleBox title={t("risk_assasement-in-pregnancy.prophylaxis-decision")} />
                        <Box sx={{ padding: "10px", marginTop: "5px" }}>

                            <ByzMuiTextField
                                fullWidth
                                multiline
                                rows={5}
                                value={masterFormData.PROPHYLAXIS_DECISION || ""}
                                onChange={(e) => handleMasterChange("PROPHYLAXIS_DECISION", e.target.value)}
                                disabled={!extraAccess}
                            />
                        </Box>
                    </Box>
                </Grid>

            </Grid>
        </Card>
    );
}

export default VteRiskFactorDescription;
